import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import ZoneOverview from './components/ZoneOverview';
import ComparisonTable from './components/ComparisonTable';
import FAQSection from './components/FAQSection';
import LatestArticles from './components/LatestArticles';
import { faqs } from '@/mocks/articles';

const websiteSchema = {
  '@type': 'WebSite',
  name: '一区二区三区完整导航指南',
  url: 'https://hnatawindow.cn/',
  description: '最全面的一区二区三区导航指南，提供分区说明与实用指南，帮助用户快速了解划分标准、核心差异及使用场景。',
  inLanguage: 'zh-CN',
};

const organizationSchema = {
  '@type': 'Organization',
  name: '分区导航指南',
  url: 'https://hnatawindow.cn/',
  description: '专注一区二区三区内容导航与知识服务',
};

const faqSchema = {
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

const breadcrumbSchema = {
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://hnatawindow.cn/' },
  ],
};

export default function Home() {
  useEffect(() => {
    document.title = '一区二区三区完整导航指南 | 分区划分标准·核心差异·使用场景全解析';
  }, []);

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <SchemaOrg type="BreadcrumbList" data={breadcrumbSchema} />

      <Header />

      <main>
        <HeroSection />
        <ZoneOverview />
        <ComparisonTable />
        <FAQSection />
        <LatestArticles />
      </main>

      <Footer />
    </>
  );
}